import React from "react";
import { graphql } from "gatsby";

import ArticleListItem from "../components/article-list-item";

import Header from "../components/header";
import Footer from "../components/footer";
import Banner from "../components/banner";
import "../components/global_styles.css";
import "../components/home_styles.css";
/* import Categories from "../components/categories"; */
import Pagination from "../components/pagination";

/* import Image from "../components/image"; */
import SEO from "../components/seo";
class IndexPageMd extends React.Component {
  render() {
    const { data } = this.props;
    const articles = data.allMdx.edges;

    return (
      <>
        <SEO title="Todos los artículos" />

        <div className="wrapper">
          <Header />
          <Banner />

          <main>
            <section className=" w-5/6 mx-auto ">
              <div className="pt-4 ">
                <h1 className="mt-4 mb-4 text-grey-dark">Artículos</h1>
                {/* <Categories /> */}
              </div>
              <div className="my-8 pb-8 -mb-1">
                {articles.map(article => {
                  return (
                    <ArticleListItem
                      article={article.node}
                      key={article.node.id}
                    />
                  );
                })}
              </div>
            </section>
            <Pagination pageContext={this.props.pageContext} />
          </main>
          <Footer />
        </div>
      </>
    );
  }
}

export const blogListQuery = graphql`
  query blogListQuery($skip: Int!, $limit: Int!) {
    allMdx(
      sort: { order: DESC, fields: [frontmatter___date] }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          excerpt
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "YYYY-MM-DD")

            tags
            image {
              childImageSharp {
                fluid(maxWidth: 650) {
                  ...GatsbyImageSharpFluid_withWebp_tracedSVG
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default IndexPageMd;
